"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set_deleteVal = void 0;
//can be only set or delete, since the get in this is deprecated
var set_deleteVal = function (action, data, valuePath, value) {
    if (valuePath === undefined)
        return;
    if (valuePath === null && action === 'set') {
        data = value;
        return data;
    }
    var dataRef = data; // a moving reference to internal objects within data
    var keysArray = valuePath.split('.');
    // var keysArray = valuePath;
    var len = keysArray.length;
    var valIsUndefined = false;
    for (var i = 0; i < len - 1; i++) {
        var key = keysArray[i];
        /**
         * maybe another check is needed here to see if dataRef[key] is a string,
         * cuz if it is, we must reset it to an object. cuz for sure, once this loop is
         * over, there IS another key, that will be attached to the dataRef.
         */
        if (!dataRef[key]) {
            if (action === 'set') {
                var nextKey = keysArray[i + 1];
                /**
                 * very important:
                 * what this does is,
                 * - here, we are in a situation where some key along the valuePath trail doesnt seem to exist
                 * - so against that key, we need to now create an object or an array
                 * - how do we decide?
                 * - by checking if the next key is a number or not
                 */
                if (nextKey && !isNaN(parseInt(nextKey))) { //next key IS a number then..
                    dataRef[key] = [];
                }
                else {
                    dataRef[key] = {};
                }
            }
            else {
                //action === get
                valIsUndefined = true;
                break;
            }
        }
        dataRef = dataRef[key]; //if key is a number (as a string) the code recognizes it as an ary idx; so arrays also work with this func. !
    }
    if (valIsUndefined)
        return undefined; //if the loop above is broken because we didnt find anything at one of the keys, then return undefined;
    if (action === 'set') {
        dataRef[keysArray[len - 1]] = value;
        return data;
    }
    else if (action === 'delete') {
        /**
         * very important that we handle Array situations by 'splicing'
         * rather than deleting, cuz 'delete' leaves an 'empty slot' in the
         * array rather than removing the item completely which causes all
         * sorts of problems.
         */
        if (Array.isArray(dataRef)) {
            dataRef.splice(parseInt(keysArray[len - 1]), 1);
        }
        else {
            delete dataRef[keysArray[len - 1]];
        }
        return data;
    }
};
exports.set_deleteVal = set_deleteVal;
